import { AxiosResponse } from 'axios';
import { TEAMS_API } from './axios';
import { config } from 'config/config.local';

export const getTableCsvExport = (
  exportType: string,
  params: Record<string, unknown>
): Promise<AxiosResponse<Blob>> => {
  return TEAMS_API.get(`${config.routes.analytics.exports.table}${exportType}.csv`, {
    params,
    responseType: 'blob',
  });
};

export interface PageExportPreflightPayload {
  format: 'pdf' | 'zip';
  account_id: string;
  export_types: string[];
  team_ids?: string[];
  date_from?: string | null;
  date_to?: string | null;
  period?: string | null;
  filters?: Record<string, unknown>;
  active_ordering?: { export_type: string; ordering: string };
}

export interface PageExportPreflightResponse {
  row_counts_by_export_type: Record<string, number>;
  will_truncate_pdf: boolean;
  tables_over_row_limit: string[];
}

export const getPageExportPreflight = (
  payload: PageExportPreflightPayload
): Promise<AxiosResponse<PageExportPreflightResponse>> => {
  return TEAMS_API.post(config.routes.analytics.exports.preflight, payload);
};

export const getPageExportGenerate = (formData: FormData): Promise<AxiosResponse<Blob>> => {
  return TEAMS_API.post(config.routes.analytics.exports.page, formData, {
    responseType: 'blob',
  });
};
